import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Upload, Spin } from 'antd'
import MyIcon from '../../components/general/icon'
import { apiBaseURL } from '../../request'

const ImportIngredient = (props) => {
  const [isLoading, setIsLoading] = useState(false)

  const imageUpload = {
    name: 'excel',
    action: `${apiBaseURL}/auth/excel/upload`,
    headers: {
      authorization: localStorage.getItem('token'),
    },
    onChange(info) {
      if (info.file.status === 'done') {
        handleImport(info.file.response.data.excel_url)
      }
    },
  }

  const handleImport = (filename) => {
    setIsLoading(true)
    axios.post('/admin/content/basic_ingredient/import', { 
      filename: filename
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('数据导入成功！')
          setIsLoading(false)
          props.getIngredientData()
          props.isCancel()
        } else {
          message.error(response.msg)
          setIsLoading(false)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleDownload = () => {
    setIsLoading(true)
    const link = document.createElement('a')
    link.href = 'https://oss.yunzhaosoft.com/templates/%E5%9F%BA%E7%A1%80%E9%A3%9F%E6%9D%90%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
    link.setAttribute('download', '')
    link.click()
    setIsLoading(false)
  }

  return (
    <>
      <Modal
        width={500}
        title="基础食材导入和导出"
        open={props.isOpen}
        onCancel={props.isCancel}
        footer=''>
        
        <Spin spinning={isLoading}>
          <div className='public-import-container'>
            <div className='public-import-box'>
              <div className='public-import-icon'>
                <MyIcon name='daoru' />
              </div>
              <div className='public-import-title'>从本地导入</div>
              <div className='public-import-despcription'>导入数据前请先下载导入模版，根据模版格式导入</div>
              
              <Upload {...imageUpload} showUploadList={false}>
                <div className='public-import-button1'>
                  <p>导入数据</p>
                </div>
              </Upload>
              
              <div className='public-import-button2' onClick={() => { handleDownload() }}>
                <p>下载模版</p>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  )
}

export default ImportIngredient
